import { TenantEntity } from '@/class/model/TenantEntity'

export class DataSyncBase extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get externalId() {
    return this._data.externalId
  }
  set externalId(externalId) {
    this._data.externalId = externalId
  }
}
